import {
  getCurrentCognitoUser,
  requireMFASetup,
  requireMFAValidation,
  urlSafeDecode,
} from '../../../utils/helper';

import { FederatedHandlerResponse } from './types';

const stateRegex = new RegExp('state=(.*?)&');

const checkIfSignup = (callback: string): Boolean => {
  const returnedState = stateRegex.test(callback)
    ? callback.match(stateRegex)![1]
    : '';
  const passedState = returnedState.includes('-')
    ? urlSafeDecode(returnedState.split('-')[1])
    : '';
  return passedState !== 'li';
};

export const handleCallbackSuccess = async (
  callback: string,
  mfaToken: string | undefined,
  clientId: string
): Promise<FederatedHandlerResponse> => {
  try {
    const signup = checkIfSignup(callback);

    if (signup) {
      return { status: 'signUp', user: null };
    } else {
      const cognitoUser = await getCurrentCognitoUser();

      if (requireMFASetup(cognitoUser.attributes))
        return { status: 'MFASetupRequired', user: null };
      else if (await requireMFAValidation(mfaToken, clientId))
        return { status: 'MFAValidateRequired', user: null };
      else {
        return { status: 'authenticated', user: cognitoUser };
      }
    }
  } catch (e: any) {
    return {
      status: 'error',
      error: 'Something went wrong please try after sometime.',
      user: null,
    };
  }
};
